import { render } from "./Play.vue?vue&type=template&id=7b92d2dc"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"
script.render = render

export default script